import React from "react";
import { css } from "@emotion/react";
import { CometChat } from "@cometchat-pro/chat";
import { MsgPosition } from "components/chat/types";
import Sender from "components/chat/shared/Sender";
import TimeStamp from "components/chat/shared/TimeStamp";
import { bubbleStyle } from "components/chat/shared/BubbleUtil";
import DotMenu from "components/atoms/DotMenu";

// mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const style = {
  imgWrap: css`
    display: inline-block;
    height: 200px;
    max-width: 300px;
    cursor: pointer;
  `,
  img: css`
    height: 100%;
    border-radius: 8px;
  `,
};

type BubbleImageProps = {
  msg: CometChat.MediaMessage;
  position: MsgPosition;
  isMyMsg: boolean;
  handleMsgDelete: (msg: CometChat.BaseMessage) => void;
};
const BubbleImage: React.FC<BubbleImageProps> = (props) => {
  const { msg, position, isMyMsg, handleMsgDelete } = props;

  const handleDelete = () => {
    handleMsgDelete(msg);
  };

  return (
    <Box css={bubbleStyle.root(position)}>
      <Box css={bubbleStyle.child}>
        <Box css={bubbleStyle.box(position)}>
          <Sender sender={msg.getSender()} />
        </Box>
        <Box css={style.imgWrap}>
          <a href={msg.getURL()} target="_blank" rel="noreferrer">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img alt="image" css={style.img} src={msg.getURL()} />
          </a>
        </Box>
        <Box css={bubbleStyle.box(position)}>
          <Stack direction="row" alignItems="center">
            {isMyMsg && (
              <DotMenu
                options={[
                  {
                    children: <>delete</>,
                    handleClick: handleDelete,
                  },
                ]}
              />
            )}
            <TimeStamp msg={msg} />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default BubbleImage;
